import { render, staticRenderFns } from "./AffiliateSetting.vue?vue&type=template&id=ed838f82&"
import script from "./AffiliateSetting.vue?vue&type=script&lang=js&"
export * from "./AffiliateSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports